module.exports = __webpack_public_path__ + "static/media/zachary-staines.f8959224.jpg";